import { render, staticRenderFns } from "./SettingsInvoiceSeries.vue?vue&type=template&id=4ff0f69e"
import script from "./SettingsInvoiceSeries.vue?vue&type=script&lang=js"
export * from "./SettingsInvoiceSeries.vue?vue&type=script&lang=js"
import style0 from "./SettingsInvoiceSeries.vue?vue&type=style&index=0&id=4ff0f69e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports